import { z } from 'zod'
import { type DigitalMenuAppSetting } from '../../models/AppSetting'
import { mapDTOToSlimModel, SlimModelDTO } from '~/domain/shared/slim/gateways/DTOs/SlimModelDTO'

const DigitalMenuThemeSettingDTO = z.object({
  primary_color: z.string(),
  secondary_color: z.string()
})

const DigitalMenuWelcomeScreenSettingDTO = z.object({
  welcome_message: z.string().nullish(),
  finish_message: z.string().nullish()
})

const DigitalMenuUseParamsSettingDTO = z.object({
  isHiddenButtonCloseAccount: z.boolean(),
  isHiddenButtonWaiterCall: z.boolean()
})

export const DigitalMenuAppSettingDTO = z.object({
  theme: DigitalMenuThemeSettingDTO,
  welcome_screen: DigitalMenuWelcomeScreenSettingDTO,
  use_params: DigitalMenuUseParamsSettingDTO,
  customization_id: z.number().nullish(),
  customization: SlimModelDTO.nullish()
})

export type DigitalMenuAppSettingDTO = z.infer<typeof DigitalMenuAppSettingDTO>

function normalizeHexColor (color: string | undefined): string {
  if (!color) { return '' }
  const cleaned = color.replace('#', '')
  return cleaned ? `#${cleaned}` : ''
}

export function mapDigitalMenuAppSettingToDTO (model: DigitalMenuAppSetting): DigitalMenuAppSettingDTO {
  return {
    theme: {
      primary_color: normalizeHexColor(model.theme.primaryColor),
      secondary_color: normalizeHexColor(model.theme.secondaryColor)
    },
    welcome_screen: {
      welcome_message: model.welcomeScreen.welcomeMessage ?? '',
      finish_message: model.welcomeScreen.finishMessage ?? ''
    },
    use_params: {
      isHiddenButtonCloseAccount: model.useParams.isHiddenButtonCloseAccount,
      isHiddenButtonWaiterCall: model.useParams.isHiddenButtonWaiterCall
    },
    customization_id: model.customization?.id
  }
}

export function mapDTOToDigitalMenuAppSetting (dto: DigitalMenuAppSettingDTO): DigitalMenuAppSetting {
  return {
    theme: {
      primaryColor: dto.theme.primary_color ?? '',
      secondaryColor: dto.theme.secondary_color ?? ''
    },
    welcomeScreen: {
      welcomeMessage: dto.welcome_screen.welcome_message ?? '',
      finishMessage: dto.welcome_screen.finish_message ?? ''
    },
    useParams: {
      isHiddenButtonCloseAccount: dto.use_params.isHiddenButtonCloseAccount,
      isHiddenButtonWaiterCall: dto.use_params.isHiddenButtonWaiterCall
    },
    customization: dto.customization ? mapDTOToSlimModel(dto.customization) : undefined
  }
}
